
import FastImage from "../../../../globals/elements/fastimg"
import { publicUrlFor } from "../../../../globals/constants"
export default function Testimonial({
    options,
    data, 
})
{
    return <div className="section-full p-t80 p-b80 bg-center bg-full-height bg-no-repeat bg-gray" style={{ backgroundImage: `url(${publicUrlFor("images/background/bg-map.png")})` }}>
        <div className="container">
            {/* TITLE START */}
            <div className="section-head text-center">
                <h2 data-title="Testimonials">{options?.title}</h2>
                <div className="mt-separator-outer">
                    <div className="mt-separator site-bg-primary" />
                </div>
            </div>
            {/* TITLE END */}
            <div className="section-content">
                <div className="owl-carousel home-carousel-1">
                    {
                        data && data.length > 0 && data.map((item,index) => {
                            return (
                                <div className="item" key={`item-${index}`}>
                                    <div className="testimonial-2  clearfix bg-white">
                                        <div className="testimonial-detail">
                                            <div className="testimonial-pic shadow"><FastImage src={item?.img?.url} width={100} height={100} alt="" /></div>
                                        </div>
                                        <div className="testimonial-text">
                                            <strong className="testimonial-name">{item?.title} </strong>
                                            <span className="testimonial-position">{item?.post}</span>
                                            <span className="fa fa-quote-left" />
                                            <p>{item?.description}.</p>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                   
                </div>
            </div>
        </div>
    </div>
}